import { useEffect, useRef, useState } from 'react'
import { usePosition } from './use-position'
import { useWorld } from './use-world'

import styled from 'styled-components'

const MapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  align-self: stretch;
  align-content: stretch;
  overflow: hidden;
  border: #660033 1px solid;
`

const MapGrid = styled.div`
  ${({
    width = 200,
    height = 100,
    left = 0,
    background = 'rgba(55,75,105,0.5)'
  } = {}) => `
  box-sizing: border-box;
  position: absolute;
  left: ${left};
  top: 0;
  width: ${width}px;
  height: ${height}px;
  cursor: pointer;
    `}
`

const MapTile = styled.div.attrs(({ x, y, background }) => ({
  style: {
    left: `${x}px`,
    top: `${y}px`,
    background: `${background}`
  }
}))`
  position: absolute;
  width: 20px;
  height: 20px;
  pointer-events: none;
`

const Tile = ({ position, bgColor, solid }) => {
  const [p] = usePosition(position.x, position.y, 20, 20, {
    solid
  })
  return <MapTile {...position} background={bgColor}></MapTile>
}

const isInsideBoundingBox = (parent, child) => {
  return {
    top: child.top < parent.top,
    right: child.right > parent.right,
    bottom: child.bottom > parent.bottom,
    left: child.left < parent.left
  }
}

export const Map = ({ children, data }) => {
  const mapRef = useRef()
  const container = useRef()
  const [box, setBox] = useState({
    width: 300,
    height: data.tiles.length * data.grid
  })
  const { offset, sprites, setContainer, setOffset, setTarget } = useWorld()
  const [tiles, setTiles] = useState(data.tiles)

  const handleMapClick = (e) => {
    if (!mapRef.current) return
    const rect = mapRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top
    setTarget({ x, y })
  }

  const getParams = (tile, index, row, offset) => {
    return {
      ...tile,
      id: `${row}_${tile}`,
      position: {
        x: index * data.grid,
        y: row * data.grid
      }
    }
  }

  const playerShouldMoveMap = (direction) => {
    const frame = container?.current
    if (!frame) return false
    switch (direction) {
      case 'left':
        return (
          sprites?.player.position.x <= frame.offsetWidth / 2 &&
          sprites?.player?.position.direction?.indexOf('left') > -1
        )
      case 'right':
        return (
          sprites?.player.position.x >= frame.offsetWidth / 2 + data.grid &&
          sprites?.player?.position.direction?.indexOf('right') > -1
        )
      default:
        return false
    }
  }
  const shouldMoveMap = (player = {}) => {
    const frame = container.current.getBoundingClientRect()
    const contents = mapRef.current.getBoundingClientRect()
    const overlaps = isInsideBoundingBox(frame, contents)
    if (overlaps.right && playerShouldMoveMap('right')) {
      setOffset({
        ...offset,
        x: Math.ceil(offset.x + -data.grid)
      })
    }
    if (overlaps.left && playerShouldMoveMap('left')) {
      setOffset({
        ...offset,
        x: Math.ceil(offset.x + data.grid)
      })
    }
  }

  useEffect(() => {
    // const col = Math.ceil(clientX / map.grid);
    if (mapRef.current && sprites?.player) {
      shouldMoveMap(sprites?.player)
    }
  }, [sprites?.player])

  useEffect(() => {
    const frame = mapRef.current.getBoundingClientRect()
    setContainer(frame)
  }, [mapRef])

  return (
    <MapContainer id="barfly_viewport" ref={container}>
      <MapGrid {...box} left={`${offset.x}px`} ref={mapRef} onClick={handleMapClick}>
        {tiles.map((row, r) => {
          const rowX = row.length * data.grid
          if (box.width < rowX) {
            setBox({ ...box, width: rowX })
          }
          return row.map((tile, i) => (
            <Tile key={`${r}_${i}`} {...getParams(tile, i, r)} />
          ))
        })}
        {children}
        <MapTile />
      </MapGrid>
    </MapContainer>
  )
}
